import { Component } from '@angular/core';
import { BaseFormValidationMessagesComponent } from '../base-form-validation-messages.component';

@Component({
  selector: 'ui-form-validation-messages',
  templateUrl: './form-validation-messages.component.html',
  styleUrls: ['./form-validation-messages.component.scss'],
})
export class FormValidationMessagesComponent extends BaseFormValidationMessagesComponent {}
